import axios from 'axios';

const Api_Url = "https://explera.earnlancer.in";
// const Api_Url = "https://expleradmc-backend.vercel.app";
// const Api_Url = "http://localhost:8080";

const Get_Api = async (EndPoint) => {
    try {
        const response = await axios.get(`${Api_Url}/${EndPoint}`, {
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching data:', error);
        throw error;
    }
};


const Delete_Api = async (EndPoint) => {
    try {
        const response = await axios.delete(`${Api_Url}/${EndPoint}`, {
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
        });
        return response.data;
    } catch (error) {
        console.error('Error deleting data:', error);
        throw error;
    }
};


const formatDate = (isoString) => {
    const date = new Date(isoString);

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
};
const formatDateonly = (isoString) => {
    const date = new Date(isoString);

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return `${day}-${month}-${year}`;
};

const Update_Api = async (EndPoint, data) => {
    try {
        const response = await axios.put(`${Api_Url}/${EndPoint}`, data, {
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
        });
        return response.data;
    } catch (error) {
        console.error('Error updating data:', error);
        throw error;
    }
};
const Create_Api = async (EndPoint, data) => {
    try {
        const response = await axios.post(`${Api_Url}/${EndPoint}`, data, {
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
        });
        return response.data;
    } catch (error) {
        console.error('Error Creating data:', error);
        throw error;
    }
};


const formatDate2 = (isoString) => {
    const date = new Date(isoString);
    return date.toLocaleString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: true,
    });
};


export { Get_Api, Delete_Api, formatDate, formatDateonly, Update_Api, Create_Api,formatDate2};
